import {DefaultTheme} from 'styled-components';

import {ChartToolbarHighlights} from '../types/ChartToolbarHighlight';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {isNewVehicleInAdvertisement} from './isNewVehicleInAdvertisement';
import {isVehicleMatchingSelectedSeller} from './isVehicleMatchingSelectedSeller';

interface GetChartHighlightBorderColorParams {
  theme: DefaultTheme;
  car: ExtendedStatisticsCar | undefined;
  highlights: ChartToolbarHighlights;
  selectedSellerId: string | null;
}

/**
 * Shared border/cap color for chart highlight encodings.
 * Priority: selected dealer → suspicious → new.
 */
export function getChartHighlightBorderColor(
  params: GetChartHighlightBorderColorParams
): string | null {
  const showDealerBorder =
    params.car !== undefined &&
    isVehicleMatchingSelectedSeller(params.car, params.selectedSellerId);
  const showSuspiciousBorder = params.highlights.suspicious && params.car?.suspicious === true;
  const showNewBorder =
    params.highlights.new && params.car !== undefined && isNewVehicleInAdvertisement(params.car);

  if (showDealerBorder) {
    return params.theme.colors.palettes.blue['60']['100'];
  }

  if (showSuspiciousBorder) {
    return params.theme.colors.severity.danger;
  }

  if (showNewBorder) {
    return params.theme.colors.palettes.green['60']['100'];
  }

  return null;
}
